import script from "./FormCharacteristicsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCharacteristicsComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormCharacteristicsComponent.vue?vue&type=style&index=0&id=4391a84c&lang=css"

const __exports__ = script;

export default __exports__